
<div
  class="board"
  [class.solved]="completed === 8"
  [style.backgroundImage]="'url(' + backgroundImage + ')'"
>
  <div
    class="singlePiece"
    [class.inPosition]="piece.inPosition"
    [class.empty]="!piece.playable"
    [style.width]="config.piecesWidth + 'px'"
    [style.height]="config.piecesWidth + 'px'"
    [style.top]="piece?.actualPosition.top + 'px'"
    [style.left]="piece?.actualPosition.left + 'px'"
    *ngFor="let piece of pieces; let i = index"
    [ngStyle]="{
      'background-image':
        'url(' + backgroundImage + ')',
      'background-size': config.boardWidth + 'px',
      'background-position': '-' + piece.left + 'px ' + '-' + piece.top + 'px'
    }"
    (click)="movePiece(i)"
  >
    <span class="numberHint" *ngIf="hint && piece.id !== pieces.length">{{
      piece.id
    }}</span>
  </div>
</div>
<div class="text-center">
  <span class="btn btn-primary" (click)="hint = !hint">Mostra aiuto</span>
  <span class="btn btn-primary" (click)="solve()">Risolvi</span>
</div>
